import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "PlaySmall.svg",
  "use": "PlaySmall.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol viewBox=\"0 0 64 64\" xmlns=\"http://www.w3.org/2000/svg\" id=\"PlaySmall.svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23.1107 41.8605L42.266 31.325L23.1107 20.7896V41.8605ZM17.7773 17.7829V44.8672C17.7773 47.5715 20.6768 49.2859 23.0464 47.9826L47.6685 34.4405C50.1246 33.0896 50.1246 29.5604 47.6685 28.2096L23.0464 14.6674C20.6768 13.3642 17.7773 15.0785 17.7773 17.7829Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol